'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsonToCsv = require('./json-to-csv');

var _jsonToCsv2 = _interopRequireDefault(_jsonToCsv);

var _copyTextToClipboard = require('./copy-text-to-clipboard');

var _copyTextToClipboard2 = _interopRequireDefault(_copyTextToClipboard);

var _colorFinder = require('./color-finder');

var _colorFinder2 = _interopRequireDefault(_colorFinder);

var _hourFinder = require('./hour-finder');

var _hourFinder2 = _interopRequireDefault(_hourFinder);

var _startFinder = require('./start-finder');

var _startFinder2 = _interopRequireDefault(_startFinder);

var _validIndexes = require('./valid-indexes');

var _validIndexes2 = _interopRequireDefault(_validIndexes);

var _dateFinder = require('./date-finder');

var _dateFinder2 = _interopRequireDefault(_dateFinder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('calApp.MiscServices', []).factory('ColorFinder', _colorFinder2.default).factory('HourFinder', _hourFinder2.default).factory('StartFinder', _startFinder2.default).factory('JSONToCSVConvertor', _jsonToCsv2.default).factory('copyTextToClipboard', _copyTextToClipboard2.default).factory('ValidIndexes', _validIndexes2.default).factory('DateFinder', _dateFinder2.default).name;


// WEBPACK FOOTER //
// ./client/components/misc-services/index.js